import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: require("./../components/animations/Raya.vue").default,
  },
  {
    path: "/animations/rain",
    name: "rain",
    component: require("./../components/animations/RainEffect.vue").default,
  },
  {
    path: "/animations/snow",
    name: "snow",
    component: require("./../components/animations/SnowEffect.vue").default,
  },
  {
    path: "/animations/firework",
    name: "firework",
    component: require("./../components/animations/FireworkEffect.vue").default,
  },
  {
    path: "/games/moving-button",
    name: "MovingButton",
    component: require("../components/games/MovingButton.vue").default,
  },
  {
    path: "/games/tetris",
    name: "TetrisGame",
    component: require("../components/games/TetrisGame.vue").default,
  },
  {
    path: "/games/bubble",
    name: "BubbleGame",
    component: require("../components/games/BubbleGame.vue").default,
  },
  {
    path: "/games/color-bubble",
    name: "BlueBubbleEffect",
    component: require("../components/games/ColouredBubbleEffect.vue").default,
  },
  {
    path: "/games/puzzle",
    name: "FunPuzzle",
    component: require("../components/games/FunPuzzle.vue").default,
  },
  // {
  //   path: "/games/puzzledeep",
  //   name: "FunPuzzle",
  //   component: require("../components/games/FunPuzzledeep.vue").default,
  // },
  {
    path: "/features/convert-listing-table",
    name: "convert-listing-table",
    component: require("./../components/features/ConvertListingToTable.vue")
      .default,
  },
  {
    path: "/learning/bubble-wording",
    name: "bubble-wording",
    component: require("./../components/learning/BubbleWording.vue").default,
  },
  {
    path: "/test",
    name: "test",
    component: require("./../components/HelloWorld.vue").default,
  },
];

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
// const app = new Vue({
//   router
// }).$mount('#app')

export default router;
